/**
 *  CDB客人资料参团记录查询
 */
import { axios } from '@/utils/request'

const subPath = '/cdb/customer/tourRecords'

export default {
  query,
  queryTotalByCustomerId
}

// 分页查询
function query (parameter) {
  return axios({
    url: `${subPath}/query`,
    method: 'get',
    params: { ...parameter, 'page.curPage': parameter.curPage, 'page.pageSize': parameter.pageSize }
  })
}

// 统计单个客人的各类参团记录总数
function queryTotalByCustomerId (customerId) {
  return axios({
    url: `${subPath}/queryTotalByCustomerId/${customerId}`,
    method: 'get'
  })
}
